import React from 'react';
import { Link } from 'react-router-dom';

function Head({ title = 'El mejor Kebab de la ciudad', subtitle = 'Ver Menú' }) {
    return (
        <header className="bg-white shadow-md sticky top-0 z-10">
            <div className="container mx-auto py-4 px-6 flex items-center justify-between">
                <a href="#" className="flex items-center">
                    <img
                        src="https://i.ibb.co/HfYChhcf/LOGO-REDONDO-page-0001-removebg-preview.png"
                        alt="CasaBlanca Kebab Logo"
                        classNameName="h-12 shadow-logo"
                        style={{ width: '10%' }}
                    />

                    {/*    <span className="text-xl font-bold text-gray-800 ml-2">CasaBlanca Kebab</span> */}
                </a>
                <nav>
                    <ul className="flex space-x-6">
                        <li><a href="#menu" className="text-gray-700 hover:text-primary">Menú</a></li>
                        <li><a href="#ubicacion" className="text-gray-700 hover:text-primary">Ubicación</a></li>
                    </ul>
                </nav>
            </div>
        </header>

    );
}

export default Head;
